import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import { useGetFactoryListQuery } from '@/api/commonApis';
import { formatFactoryOptions, formatSampleTypeOptions } from '@/features/sampleDevelopment/utils';

const SendToFactoryBuyerDevForm = ({
	handleChange,
	requestValues,
	errors,
	brands = [],
	sampleTypeList = [],
	projectList = [],
	isDisabeleBrand
}) => {
	const { data: factoryList } = useGetFactoryListQuery({ params: { page: 0, size: 1000 } });

	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-3 gap-3">
				<FormGroupWrapper labelTitle="Customer name">
					<CustomDropdown
						title="Select brand"
						onItemClick={(value) => handleChange('brand', value)}
						selectedItem={
							requestValues?.primaryTargetCustomar?.name || requestValues?.brand?.name
						}
						items={brands?.map((brand) => ({
							...brand,
							value: brand.name
						}))}
						isDisabled={isDisabeleBrand}
					/>
				</FormGroupWrapper>
				<FormGroupWrapper labelTitle="Project name">
					<CustomDropdown
						title="Select project name"
						onItemClick={(value) => handleChange('projectName', value)}
						selectedItem={requestValues?.projectName?.text}
						items={projectList?.map((project) => ({
							...project,
							value: project.text
						}))}
					/>
					{errors?.projectName && <p className="error">{errors?.projectName}</p>}
				</FormGroupWrapper>
				<FormGroupWrapper labelTitle="Sample type*">
					<CustomDropdown
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(sampleTypeList)}
					/>
					{errors?.sampleType && <p className="error">{errors?.sampleType}</p>}
				</FormGroupWrapper>
			</div>
			<div className="flied-item d-grid grid-columns-3 gap-3">
				<InputWrapper labelTitle="Submission to AM/BDM plan date*">
					<InputField
						type="date"
						name="factorySubmitionToNitexDate"
						value={requestValues?.factorySubmitionToNitexDate}
						onChangeHandler={(e) => handleChange('factorySubmitionToNitexDate', e.target.value)}
						withWrapper={false}
						withLabel={false}
						errors={errors?.factorySubmitionToNitexDate}
					/>
				</InputWrapper>
				<FormGroupWrapper labelTitle="Factory name*">
					<CustomDropdown
						title="Select factory name"
						onItemClick={(value) => handleChange('factoryName', value)}
						selectedItem={requestValues?.factoryName?.name}
						items={formatFactoryOptions(factoryList)}
					/>
					{errors?.factoryName && <p className="error">{errors?.factoryName}</p>}
				</FormGroupWrapper>

				<InputWrapper labelTitle="Expected Order Date">
					<InputField
						type="date"
						name="expectedOrderDate"
						value={requestValues?.expectedOrderDate}
						onChangeHandler={(e) => handleChange('expectedOrderDate', e.target.value)}
						withWrapper={false}
						withLabel={false}
						errors={errors?.expectedOrderDate}
					/>
				</InputWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToFactoryBuyerDevForm;
